module.exports = __webpack_public_path__ + "fonts/fa-solid-900---2aa6edf8f296a43b32df35f330b7c81c.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/fontawesome-free/webfonts/fa-solid-900.ttf
// module id = 379
// module chunks = 0